import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { StorageServiceAAA } from './aaa-storage.service';

declare var gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  public gaParams:any;
  private readonly isBrowser: boolean;
  private initialized = false;

  constructor(private router: Router,private storage: StorageServiceAAA, @Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
   
  }

  public event(eventName: string, params: {}) {
    // if (!this.isBrowser || !this.gaParams) {
    //   return;
    // }
    // const gtagFn = (window as any)?.gtag;
    // if (typeof gtagFn === 'function') {
    //   gtagFn('event', eventName, params);
    // }
  }

  public init() {
    // if (!this.isBrowser || this.initialized) {
    //   return;
    // }
    // this.initialized = true;
    // this.listenForRouteChanges();

    // try {
    //   if (!this.gaParams) {
    //     return;
    //   }

    //   const script1 = document.createElement('script');
    //   script1.async = true;
    //   script1.src = 'https://www.googletagmanager.com/gtag/js?id=' + this.gaParams;
    //   document.head.appendChild(script1);

    //   const script2 = document.createElement('script');
    //   script2.text = `
    //     window.dataLayer = window.dataLayer || [];
    //     function gtag(){window.dataLayer.push(arguments);}
    //     gtag('js', new Date());
    //     gtag('config', '${this.gaParams}', {'send_page_view': false});
    //   `;
    //   document.head.appendChild(script2);
    // } catch (ex) {
    //   console.error('Error appending google analytics');
    //   console.error(ex);
    // }
  }

  private listenForRouteChanges() {
    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     if (!this.isBrowser || !this.gaParams) {
    //       return;
    //     }
    //     const gtagFn = (window as any)?.gtag;
    //     if (typeof gtagFn !== 'function') {
    //       return;
    //     }
    //     gtagFn('config', this.gaParams, {
    //       'page_path': event.urlAfterRedirects
    //     });
    //    // console.log('Sending Google Analytics hit for route', event.urlAfterRedirects);
    //   }
    // });
  }
}